import { removeJob } from '../State/jobs'

export default (key) => (dispatch) => {
  
  dispatch(removeJob({ key }))
  
}
